// Switching a country, city or zone off in Geo Data switches off every hotel under it. The
// save toast has to say so — quietly deactivating hotels (sometimes thousands) would be a
// nasty surprise, and the operator needs to know it happened to undo it.
//
// Shared by the Country, City and Zone managers so the three read identically.
export const geoCascadeMessage = ({ switchedOff = 0, restored = 0 } = {}) => {
  const parts = [];
  if (switchedOff) {
    parts.push(`${switchedOff.toLocaleString()} hotel${switchedOff === 1 ? "" : "s"} switched off`);
  }
  if (restored) {
    parts.push(`${restored.toLocaleString()} hotel${restored === 1 ? "" : "s"} switched back on`);
  }
  return parts.length ? `Changes saved — ${parts.join(", ")}` : "Changes saved successfully";
};

export default geoCascadeMessage;
